import PropTypes from 'prop-types'
import cn from 'classnames'
import { createUseStyles } from '../../../helpers/createStyles'
import { theme } from '../../../styles/theme'

const ColorList = ({ colors = [], active, setActive }) => {
  const styles = useStyles()

  return (
    <div className={styles.root}>
      <div className={cn(styles.row, !active && 'none-active')}>
        <span className='is-caption'>Name</span>
        <span className='is-caption'>Code</span>
      </div>
      {colors.map((color, index) => (
        <button
          key={index}
          className={cn(
            styles.row,
            active === color && 'active',
            !active && 'none-active'
          )}
          onClick={() => setActive(color)}
        >
          <span>{color.name}</span>
          <span className={styles.code}>{color.code}</span>
          <div className={styles.imageContainer}>
            <img
              className={styles.thumbnail}
              src={`${color.image.asset.url}?fit=crop&h=80&w=80`}
              alt='Color preview'
            />
          </div>
        </button>
      ))}
    </div>
  )
}

const useStyles = createUseStyles({
  root: {
    marginBottom: theme.spacing(4),
    '--border-active': 'rgba(0,0,0)',
    '--border-inactive': 'rgba(0,0,0,0.1)'
  },
  row: {
    all: 'unset',
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '3fr 3fr 1fr',
    height: 58,
    alignItems: 'center',
    border: '1px solid var(--border-inactive)',
    borderWidth: '1px 0 0',
    transition: 'border-color 150ms',
    '&:first-child': {
      borderTopWidth: 0
    },
    '&:last-child': {
      borderBottomWidth: 1
    },
    '&.none-active': {
      borderColor: 'var(--border-active)'
    },
    '&:not(.none-active):nth-child(1n + 2)': {
      color: 'rgba(0,0,0,0.3)',
      '&.active': {
        color: 'inherit'
      }
    },
    '&.active': {
      borderColor: 'var(--border-active)',
      borderBottomWidth: '1px'
    },
    '.active + &': {
      borderTopWidth: 0
    },
    '& > *:nth-child(3)': {
      justifySelf: 'end'
    }
  },
  code: {
    fontSize: 12
  },
  imageContainer: {
    width: 20,
    height: 20,
    overflow: 'hidden',
    borderRadius: 10
  },
  thumbnail: {
    transform: 'translate(-20px, -20px)'
  }
})

ColorList.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.object),
  active: PropTypes.object,
  setActive: PropTypes.func.isRequired
}

export default ColorList
